import React from 'react';
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import validator from "validator";
import { withRouter } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { facilityRegisterService, saveRegisteredData, RegisterstatusChange } from "../../../services/facility/action";
import { getNpiDetails, emailValidService } from "../../../services/common/action";
import { NavLink } from "react-router-dom";


import $ from 'jquery';
import { footer } from "../../../components/footerSize";
import FacilityAgree from "../../common/Model/facilityAgree";
import { onlyAlphabets, onlyNumbers} from "../../common/keyValidation"


class FacilityReg extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      npi: "",
      emailDoc: false,
      printDoc: false,
      confirmPin: false,
      facilityName: "",
      index: 0,
      officeEmail: "",
      officePhone: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      phone: "",
      email: "",
      mobile: "",
      faxNo: "",
      dateOfBirth: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      title: "",
      iAgree: false,
      errors: {
        facilityName: "",
        faxNo: "",
        npi: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        mobile: "",
        dateOfBirth: "",
        address: "",
        iAgree: "",
        officePhone: "",
        officeEmail: "",
        city: "",
        state: "",
        zip: "",
      },
      officeEmailValid: false,
      officePhoneValid: false,
      facilityNameValid: false,
      npiValid: false,
      firstNameValid: false,
      lastNameValid: false,
      emailValid: false,
      passwordValid: false,
      confirmPasswordValid: false,
      mobileValid: false,
      firstValid: false,
      agreeSiteRulesValidMsg: "",
      confirmOtpButton: false,
      faxNoValid: false,
      addressValid: false,
      //   address2Valid: false,
      cityValid: false,
      stateValid: false,
      zipValid: false,
      stateList: [],
      agreeModal: false


    }
  }


  componentDidMount() {

    // onDocumentReady function bind
    $(document).ready(function () {
      footer("#register-content");
    });

    // onResize bind of the function
    $(window).resize(function () {
      footer("#register-content");
    });
    if (this.props.getByLocationDetails) {
      let data = this.props.getByLocationDetails.stateListObj;
      this.setState({
        stateList: data
      })
    }
    this.props.RegisterstatusChange();
  }

  agreeSiteRules = (e) => {
    this.setState(
      { iAgree: !this.state.iAgree },
      () => {
        if (this.state.iAgree) {
          this.setState({ agreeSiteRulesValidMsg: "" });
        } else {
          this.setState({
            agreeSiteRulesValidMsg:
              "Please agree to site rules"
          });
        }
      }
    );
  };


  closeAgreeModal = () => {
    this.setState({
      agreeModal: false
    })
  }

  validateField(fieldName, value) {
    const {
      errors,
      password,
      confirmPassword,
      firstNameValid,
      lastNameValid,
      emailValid,
      passwordValid,
      confirmPasswordValid,
      mobileValid,
      npiValid,
      faxNoValid,
      facilityNameValid,
      officeEmailValid,
     
      addressValid,
      // address2Valid,
      cityValid,
      stateValid,
      zipValid,

    } = this.state;

    let fieldValidationErrors = errors;
    let firstNamevalid = firstNameValid;
    let lastNamevalid = lastNameValid;
    let emailvalid = emailValid;
    let passwordvalid = passwordValid;
    let confirmPasswordvalid = confirmPasswordValid;
    let mobilevalid = mobileValid;
    let npivalid = npiValid;
    let faxNovalid = faxNoValid;
    let facilityNamevalid = facilityNameValid
    let officeEmailvalid = officeEmailValid
    let addressvalid = addressValid;
    //      let address2valid = address2Valid;
    let cityvalid = cityValid;
    let statevalid = stateValid;
    let zipvalid = zipValid;
    // let officePhonevalid = officePhoneValid

    switch (fieldName) {
      case "facilityName":
        facilityNamevalid = !(value.length < 3);
        fieldValidationErrors.facilityName = facilityNamevalid
          ? ""
          : "Facility Name should be atleast 3 characters";
        break;

      case "firstName":
        firstNamevalid = !(value.length < 3 || value.length > 20);
        fieldValidationErrors.firstName = firstNamevalid
          ? ""
          : "First Name should be 3 to 20 characters";
        break;
      case "lastName":
        lastNamevalid = !(value.length < 3 || value.length > 20);
        fieldValidationErrors.lastName = lastNamevalid
          ? ""
          : "Practice Name should be 3 to 20 characters";
        break;
      case "npi":
        npivalid = value.match(/^\d{10}$/);
        fieldValidationErrors.npi = npivalid
          ? ""
          : "Please enter valid NPI number";
        break;
      case "faxNo":
        faxNovalid = value.match(/^\d{10}$/);
        fieldValidationErrors.faxNo = faxNovalid
          ? ""
          : "Please enter valid fax number";
        break;
      case "email":
        emailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailvalid
          ? ""
          : " Please enter valid Email Address";
        break;
      case "officeEmail":
        officeEmailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.officeEmail = officeEmailvalid
          ? ""
          : " Please enter valid Email Address";
        break;
      case "mobile":
        mobilevalid = value.match(/^\d{10}$/);
        fieldValidationErrors.mobile = mobilevalid
          ? ""
          : " Please enter valid phone number";
        break;
      case "password":
        passwordvalid =
          value.length >= 8 &&
          value.match(
            /(?=.*[_!@#$%^&*-])(?=.*\d)(?!.*[.\n])(?=.*[a-z])(?=.*[A-Z])^.{8,}$/
          );
        fieldValidationErrors.password = passwordvalid
          ? ""
          : "Must contain at least one uppercase letter, one lowercase letter, one number, one special character and a minimum of 8 characters";
        break;
      case "confirmPassword":
        confirmPasswordvalid = validator.equals(value, password);
        fieldValidationErrors.confirmPassword = confirmPasswordvalid
          ? ""
          : "Password does not match";
        break;
      case "address":
        addressvalid = !(value.length < 1);
        fieldValidationErrors.address = addressvalid
          ? ""
          : "Please enter the address";
        break;

      // case "address2":
      // address2valid = !(value.length < 1);
      // fieldValidationErrors.address2 = address2valid
      // ? "" 
      // : "Please enter the address2";
      // break;

      case "city":
        cityvalid = !(value.length < 1);
        fieldValidationErrors.city = cityvalid
          ? ""
          : "Please enter the city";
        break;

      case "state":
        statevalid = !(value.length < 1);
        fieldValidationErrors.state = statevalid
          ? ""
          : "Please enter the state";
        break;

      case "zip":
        zipvalid = !(value.length < 1);
        fieldValidationErrors.zip = zipvalid
          ? ""
          : "Please enter the zip";
        break;
      default:
        break;
    }
    if (fieldName === "password") {
      if (confirmPassword !== "") {
        if (value !== confirmPassword) {
          fieldValidationErrors.confirmPassword = "Password does not match.";
        } else {
          fieldValidationErrors.confirmPassword = "";
        }
      }
    } else if (fieldName === "confirmPassword") {
      if (value !== password) {
        fieldValidationErrors.confirmPassword = "Password does not match.";
      } else {
        fieldValidationErrors.confirmPassword = "";
      }
    }

    this.setState(
      {
        errors: fieldValidationErrors,
        firstNameValid: firstNamevalid,
        lastNameValid: lastNamevalid,
        emailValid: emailvalid,
        passwordValid: passwordvalid,
        confirmPasswordValid: confirmPasswordvalid,
        mobileValid: mobilevalid,
        npiValid: npivalid,
        faxNoValid: faxNovalid,
        facilityNameValid: facilityNamevalid,
        officeEmailValid: officeEmailvalid,
        addressValid: addressvalid,
        //       address2Valid : address2valid,
        cityValid: cityvalid,
        stateValid: statevalid,
        zipValid: zipvalid,
      },
      this.validateForm
    );
  }






  validateForm() {
    const {
      faxNoValid,
      npiValid,
      lastNameValid,
      firstNameValid,
      emailValid,
      passwordValid,
      confirmPasswordValid,
      mobileValid,
      facilityNameValid,
      officeEmailValid,
      addressValid,
      //     address2Valid ,
      cityValid,
      stateValid,
      zipValid,
    } = this.state;
    this.setState({
      firstValid:
        lastNameValid &&
        firstNameValid &&
        facilityNameValid &&
        npiValid &&
        faxNoValid &&
        addressValid &&
        officeEmailValid &&
        //       address2Valid &&
        cityValid &&
        stateValid &&
        zipValid,

      secondValid:

        emailValid &&
        passwordValid &&
        confirmPasswordValid &&
        mobileValid


    });
  }



  handleChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };




  npiChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;

    this.setState({
      npi: value

    }, () => {
      this.validateField(name, value);
      if (this.state.npi.length === 10) {
        let payLoad = {
          "number": this.state.npi,
          "enumeration_type": "",
          "taxonomy_description": "",
          "first_name": "",
          "use_first_name_alias": "",
          "last_name": "",
          "organization_name": "",
          "address_purpose": "",
          "city": "",
          "state": "",
          "postal_code": "",
          "country_code": "",
          "limit": "",
          "skip": "",
          "version": ""
        }

        let page = "registration";

        this.props.getNpiDetails(payLoad, page);

      }
    })
  }

  zipChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;

    this.setState({
      zip: value

    }, () => {
      this.validateField(name, value);
      if (this.state.zip.length === 5) {
        let payLoad = {

        }

        let page = "registration";

        this.props.verifyStateService(payLoad, page);

      }
    })
  }



  componentWillReceiveProps = nextProps => {
    if (nextProps.saveRegDataStatus) {
      this.props.history.push("/FinalFacilityReg");

    }
    if (nextProps.getNpiStatus) {
      if (nextProps.getNpiData) {
        if (nextProps.getNpiData.npiInfo.map.results.myArrayList.length > 0) {


          let basic_data = nextProps.getNpiData.npiInfo.map.results.myArrayList[0].map.basic.map
          let address_data = nextProps.getNpiData.npiInfo.map.results.myArrayList[0].map.addresses.myArrayList[0].map
          let firstName = basic_data.first_name;
          let lastName = basic_data.last_name;

          let officePhone = address_data.telephone_number;
          let faxNo = address_data.fax_number;
          let address = address_data.address_1;
          let address2 = address_data.address_2;
          let city = address_data.city;
          let state = address_data.state;
          let zip = address_data.postal_code;
          zip = zip.slice(0, 5)

          let faxNoValid = faxNo ? true : false;
          let addressValid = address ? true : false;
          // let address2Valid = address2 ? true  : false; 
          let cityValid = city ? true : false;
          let stateValid = state ? true : false;
          let zipValid = zip ? true : false;
          let npiValid = true

          let lastNameValid = lastName ? true : false
          let firstNameValid = firstName ? true : false


          this.setState({
            firstName,
            lastName,
            officePhone,
            faxNo,
            address,
            address2,
            city,
            state,
            zip,
            faxNoValid,
            addressValid,
            //     address2Valid,
            cityValid,
            stateValid,
            zipValid,
            lastNameValid,
            firstNameValid,
            npiValid,

            // firstValid:
            //   faxNoValid &&
            //   addressValid &&
            //   //     address2Valid &&
            //   cityValid &&
            //   stateValid &&
            //   zipValid &&
            //   npiValid,


            // secondValid:
            //   lastNameValid &&
            //   firstNameValid


          }, () => {
            if (nextProps.getByLocationDetails) {
              let locationList = nextProps.getByLocationDetails.stateListObj;

              let stateList = locationList.filter((state) => {
                return state.state_code === this.state.state
              })

              let state = stateList[0].name
              this.setState({
                state
              })

            }
          })
        }
      }
    }


  }



  saveRegisteredData = (e) => {
    e.preventDefault();
    const {
      facilityName,
      firstName,
      lastName,
      email,
      mobile,
      faxNo,
      officeEmail,
      officePhone,
      password,
      confirmPassword,
      address,
      address2,
      city,
      title,
      state,
      zip,
      npi

    } = this.state;


    let payLoad = {
      userType: "facility",
      facilityName,
      firstName,
      lastName,
      email,
      mobile,
      faxNo,
      password,
      confirmPassword,
      address,
      address2,
      officeEmail,
      officePhone,
      city,
      state,
      zip,
      title,
      npi,
    };

    let email_id = {
      email
    }
    let mobileNum = {
      mobile
    }

    this.props.emailValidService(payLoad.userType, email_id, mobileNum, payLoad);



    //   this.props.saveRegisteredData(payLoad);
  }


  changePage = (e) => {
    e.preventDefault();
    let id = e.target.id;

    switch (id) {
      case "next":
        this.setState({
          index: this.state.index + 1
        })
        break;
      case "back":
        this.setState({
          index: this.state.index - 1
        })
        break;
        default:
        break;
    }
  }

 
  render() {
   
   // let date = moment().format("MMM Do YY");

    const {

      facilityName,
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
    
      mobile,
      faxNo,
     
      address,
      address2,
      city,
      state,
      npi,
      zip,
      iAgree,
      
      errors,
      firstValid,
      secondValid,
      officeEmail,
      officePhone,
      title,
      index
    } = this.state;

    let hrefValue = "#"
    return (
      <>


        <div className="registration-wrapper">

          <Header routes={[{ "name": "Registration", "route": "/Register", }, { "name": "Practice Registration", "route": "/FacilityReg" }]} />


          {/* <!-- Content Section --> */}
          <div className="register-content">
            <div className="container">
              <div className="form-head">
                <h1>Practice/Doctor Registration</h1>
                <label className="head-sub-title">If you are Registering as Practice, then you can add individual Doctors from your dashboard</label>
              </div>
              {index === 0 &&
                <div className="form-body">
                  <form>
                    <div className="row">

                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="fname">NPI</label><sup>*</sup>

                          <input type="text" maxLength="10" name="npi" value={npi} onKeyPress={onlyNumbers} className="form-control r-txt" id="fname"
                            onChange={this.npiChange} placeholder="NPI" />


                        </div>
                        <div style={{ color: "red" }}>{errors.npi}</div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="lname">Practice Name</label><sup>*</sup>
                          <input type="text" name="facilityName" value={facilityName} className="form-control r-txt" id="lname"
                            onChange={this.handleChange} placeholder="Practice Name" />
                          <div className="r-icon">
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{errors.facilityName}</div>

                      </div>

                    </div>
                    <div className="row">

                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="fname">First Name</label><sup>*</sup>
                          <input type="text" name="firstName" value={firstName}  onKeyPress={onlyAlphabets} className="form-control r-txt" id="fname"
                            onChange={this.handleChange} placeholder="First Name " />
                          <div className="r-icon">
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{errors.firstName}</div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="lname">Last Name</label><sup>*</sup>
                          <input type="text" name="lastName" value={lastName}  onKeyPress={onlyAlphabets} className="form-control r-txt" id="lname"
                            onChange={this.handleChange} placeholder="Last Name" />
                          <div className="r-icon">
                            <i className="fa fa-user" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">

                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="form-group r-form">
                          <label for="email">Office Email</label><sup>*</sup>
                          <input name="officeEmail" value={officeEmail} className="form-control r-txt" id="email"
                            onChange={this.handleChange} placeholder="Office Email" />
                          <div className="r-icon">
                            <i className="fa fa-envelope" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{errors.officeEmail}</div>

                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="phone">Office Phone</label>
                          <div className="mobile-code">
                            <input name="officePhone" maxLength="10" value={officePhone}
                              className="form-control r-txt r-phone" id="phone" onChange={this.handleChange} onKeyPress={onlyNumbers}
                              type="text" placeholder="Office Phone" />
                            <div className="r-icon">
                              <i className="fa fa-phone" aria-hidden="true"></i>
                            </div>
                            <div className="country-code-phone">
                              <label>+1</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="fax">Fax Number</label><sup>*</sup>
                          <div className="mobile-code">
                            <input type="text" maxLength="10"
                              name="faxNo" value={faxNo} className="form-control r-txt r-phone" id="fax"
                              onChange={this.handleChange} placeholder="Office Fax" onKeyPress={onlyNumbers} />
                            <div className="r-icon">
                              <i className="fa fa-fax" aria-hidden="true"></i>
                            </div>
                            <div className="country-code-phone">
                              <label>+1</label>
                            </div>
                          </div>

                        </div>
                        <div style={{ color: "red" }}>{errors.faxNo}</div>
                      </div>

                    </div>
                    <div className="row">


                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="address1">Address 1</label><sup>*</sup>
                          <textarea className="form-control r-txt-area" rows="2" id="address1" name="address" value={address}
                            onChange={this.handleChange} placeholder="Address"></textarea>

                        </div>
                        <div style={{ color: "red" }}>{errors.address}</div>

                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="address2">Address 2</label>
                          <textarea className="form-control r-txt-area" rows="2" id="address2" name="address2" value={address2}
                            onChange={this.handleChange} placeholder="Address2"></textarea>
                        </div>
                      </div>

                    </div>

                    <div className="row">




                    </div>
                    <div className="row">

                      <div className="col-lg-3 col-md-3 col-sm-3 col-12">
                        <div className="form-group r-form">
                          <label for="city">City</label><sup>*</sup>
                          <input type="text" name="city" value={city} className="form-control r-txt" id="city"
                            onChange={this.handleChange} placeholder="City" />
                        </div>
                        <div style={{ color: "red" }}>{errors.city}</div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-12">
                        <div className="form-group r-form">

                          <label for="state">State</label><sup>*</sup>
                          <select className="form-control" id="state" name="state" value={state} onChange={this.handleChange}>
                            <option value=""  >State </option>
                            {this.state.stateList.length > 0 ?
                              this.state.stateList.map((state, id) => {
                                return (
                                  <option value={state.name} key={id}>{state.name} </option>
                                )
                              }) : <option value="no state found"  > No state found </option>
                            }
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">

                          <label for="zip">Zip</label><sup>*</sup>
                          <input type="text" maxLength="5" name="zip" value={zip} className="form-control r-txt" id="zip"
                            onChange={this.handleChange} placeholder="Zip" onKeyPress={onlyNumbers} />
                        </div>
                        <div style={{ color: "red" }}>{errors.zip}</div>
                      </div>

                    </div>





                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="button-left">
                          <NavLink to="/Register" >
                            <button className="btn cancel-btn">Previous</button>
                          </NavLink>
                        </div>
                        <div className="button-right">
                          <button type="button" id="next" onClick={this.changePage} disabled={!firstValid} className="btn submit-btn">Next</button>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>
              }
              {index === 1 &&

                <div className="form-body">
                  <form>
                    <div className="row">

      

                    </div>
                    <div className="row">

                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="pass">Password</label><sup>*</sup>
                          <input type="password" name="password" value={password} className="form-control r-txt" id="pass"
                            onChange={this.handleChange} placeholder="Password" />
                          <div className="r-icon">
                            <i className="fa fa-lock" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{errors.password}</div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="cpass">Confirm Password</label><sup>*</sup>
                          <input type="password" name="confirmPassword" value={confirmPassword} className="form-control r-txt" id="cpass"
                            onChange={this.handleChange} placeholder="Confirm password" />
                          <div className="r-icon">
                            <i className="fa fa-lock" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{errors.confirmPassword}</div>
                      </div>

                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="email">Email</label><sup>*</sup>
                          <input type="text"  name="email" value={email} className="form-control r-txt" id="email"
                            onChange={this.handleChange} placeholder="Email" />
                          <div className="r-icon">
                            <i className="fa fa-envelope" aria-hidden="true"></i>
                          </div>
                        </div>
                        <div style={{ color: "red" }}>{errors.email}</div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">
                          <label for="title">Title</label>
                          <input type="text" name="title" value={title} className="form-control r-txt" id="title"
                            onChange={this.handleChange} placeholder="Title" />
                        </div>
                      </div>

                    </div>


                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group r-form">

                          <label for="phone">Mobile</label><sup>*</sup>
                          <div className="mobile-code">
                            <input type="text"  name="mobile" value={mobile} className="form-control r-txt r-phone" id="phone"
                              onChange={this.handleChange} placeholder="Mobile number" onKeyPress={onlyNumbers} maxLength="10" />
                            <div className="r-icon">
                              <i className="fa fa-phone" aria-hidden="true"></i>
                            </div>
                            <div className="country-code-phone">
                              <label>+1</label>
                            </div></div>
                        </div>
                        <div style={{ color: "red" }}>{errors.mobile}</div>
                      </div>

                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="button-left">
                          <button onClick={this.changePage} id="back" className="btn cancel-btn">Previous</button>
                        </div>

                        <div className="button-right">
                          <div className="form-group r-form-btn">
                            <div className="rememberme ">
                              <input type="checkbox" id="cbx"
                                onChange={this.agreeSiteRules} className="inp-cbx" />
                              <label htmlFor="cbx" className="cbx">
                                <a href={hrefValue} onClick={() => this.setState({ agreeModal: true })} className="check-agree" > I agree to Terms of Use </a>
                              </label>
                            </div>

                          </div>
                          <button disabled={!secondValid || !iAgree} onClick={this.saveRegisteredData} className="btn submit-btn">Register</button>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>
              }
              {index === 2 &&

                <div className="form-body">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                      <div className="default-section">
                        <div className="default-date">
                          <label>BUSINESS ASSOCIATES AGREEMENT:</label>
                        </div>
                      </div>
                      <div className="iframe-section">
                        <iframe src="pdf-page.html" title="docs"></iframe>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 otp-section-2">
                      <div className="bor-btm">
                        <div className="default-date">
                          <label><i className="fa fa-calendar" aria-hidden="true"></i>22-03-2019</label>
                        </div>
                        <div className="default-name">
                          <label><i className="fa fa-user" aria-hidden="true"></i>Name Of the Person</label>
                        </div></div>
                      <div className="otp-box">
                        <label>To Confirm your sign we need to send the OTP to Your Mobile and Mail</label>
                        <div className="request-otp-btn">
                          <button className="btn">Request OTP</button>
                        </div>
                      </div>
                      <div className="otp-button">
                        <button type="button" className="back-btn">Back</button>
                        <button type="button" className="accept-btn">Accepted</button>
                      </div>
                      <div className="sent-option-btn">
                        <button type="button" className="otp-email" title="Email Signed Document"><i className="fa fa-envelope" aria-hidden="true"></i> Email Signed Document</button>
                        <button type="button" className="otp-print" title="Print Signed Document"><i className="fa fa-print" aria-hidden="true"></i> Print Signed Document</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

          </div>

          {/* <!-- Footer Section --> */}
          <Footer />
        </div>

        <FacilityAgree email={email} emailValid={this.state.emailValid} status={this.state.agreeModal} closeAgreeModal={this.closeAgreeModal} />

      </>


    )
  }
}

const mapStateToProps = state => ({
  facilityRegisterDetails: state.facilityReducer.facilityRegisterDetails,
  // message: state.commonReducer.message,
  getNpiData: state.commonReducer.getNpiData,
  getNpiStatus: state.commonReducer.getNpiStatus,
  getByLocationStatus: state.patientReducer.getByLocationStatus,
  getByLocationDetails: state.patientReducer.getByLocationDetails,
  saveRegDataStatus: state.facilityReducer.saveRegDataStatus


  //isLoading: state.commonReducer.isLoading
});

const mapDispatchToProps = dispatch => ({
  facilityRegisterService: payLoad => dispatch(facilityRegisterService(payLoad)),
  RegisterstatusChange: () => dispatch(RegisterstatusChange()),
  saveRegisteredData: payLoad => dispatch(saveRegisteredData(payLoad)),
  getNpiDetails: (payload, page) => dispatch(getNpiDetails(payload, page)),
  emailValidService: (userType, email_id, mobileNum, formdata) => dispatch(emailValidService(userType, email_id, mobileNum, formdata)),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FacilityReg));